// src/isEdgeAndNodeNotNullPredicate.ts
function isEdgeAndNodeNotNullWithCursorPredicate(edge) {
  return edge != null && edge.node != null;
}
function isEdgeAndNodeNotNullPredicate(edge) {
  return edge != null && edge.node != null;
}

// src/isNotNullPredicate.ts
function isNotNullPredicate(value) {
  return value !== void 0 && value !== null;
}

// src/xray.tsx
function xray(arg) {
  console.trace("xray", arg);
  return arg;
}

// src/constants.ts
var MINUTE = 60 * 1e3;
var FIVE_MINUTES = 5 * MINUTE;
var FIFTEEN_MINUTES = 15 * MINUTE;

// src/roundMinute.ts
function roundMinute(date) {
  if (!date) {
    return null;
  }
  return new Date(Math.floor(date.getTime() / MINUTE) * MINUTE);
}

// src/roundStartTime.ts
function roundStartTime(start) {
  if (!start) {
    return null;
  }
  const time = Math.floor(roundMinute(start).getTime() / FIVE_MINUTES) * FIVE_MINUTES;
  return new Date(time);
}

// src/roundEndTime.ts
function roundEndTime(recordedStart, roundedStart, end) {
  if (!recordedStart || !roundedStart || !end) {
    return null;
  }
  const difference = roundMinute(end).getTime() - roundMinute(recordedStart).getTime();
  const overflowMinutes = difference % FIFTEEN_MINUTES / MINUTE;
  let duration = Math.floor(difference / FIFTEEN_MINUTES) * FIFTEEN_MINUTES;
  if (overflowMinutes > 1.5) {
    duration += FIFTEEN_MINUTES;
  }
  if (duration === 0) {
    duration = FIFTEEN_MINUTES;
  }
  return new Date(roundedStart.getTime() + duration);
}

// src/workUnits.ts
function workUnits(roundedStart, roundedEnd) {
  if (roundedStart === null || roundedStart === void 0 || roundedEnd === null || roundedEnd === void 0) {
    return null;
  }
  return (roundedEnd.getTime() - roundedStart.getTime()) / (3 * FIVE_MINUTES);
}

// src/colophonetic.ts
var substitution = { \u00E4: "a", \u00F6: "o", \u00FC: "u", \u00DF: "ss", ph: "f" };
var exceptions_leading = {
  4: ["ca", "ch", "ck", "cl", "co", "cq", "cu", "cx"],
  8: ["dc", "ds", "dz", "tc", "ts", "tz"]
};
var exceptions_following = ["sc", "zc", "cx", "kx", "qx"];
var coding_table = {
  0: "aeijouy",
  1: "bp",
  2: "dt",
  3: "fvw",
  4: "cgkq",
  48: "x",
  5: "l",
  6: "mn",
  7: "r",
  8: "csz"
};
function colophonetic(word) {
  if (word.indexOf(" ") !== -1) {
    return word.split(" ").map((part) => colophonetic(part)).join(" ");
  }
  word = word.toLowerCase();
  Object.entries(substitution).forEach(([subKey, subValue]) => {
    word = word.replace(new RegExp(subKey, "g"), subValue);
  });
  var value = [];
  var length = word.length;
  for (let i = 0; i < length; i++) {
    let l = word.substr(i, 1);
    value[i] = "";
    if (i === 0 && length > 1 && word[i] + word[i + 1] === "cr") {
      value[i] = 4;
    }
    Object.entries(exceptions_leading).forEach(([code, values]) => {
      if (values.includes(word[i] + word[i + 1])) {
        value[i] = parseInt(code);
      }
    });
    if (i !== 0 && exceptions_following.includes(word[i - 1] + word[i])) {
      value[i] = 8;
    }
    if (value[i] == "") {
      for (const [code, codeValue] of Object.entries(coding_table)) {
        if (codeValue.indexOf(l) !== -1) {
          value[i] = parseInt(code);
          break;
        }
      }
    }
  }
  for (let i = 1; i < length; i++) {
    if (value[i] == value[i - 1]) {
      value[i] = "";
    }
    if (value[i] == 0) {
      value[i] = "";
    }
  }
  return value.join("") + "";
}

// src/normalizeSearchTerm.ts
function normalizeSearchTerm(term) {
  return term.toLowerCase().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
}

// src/YearMonth.ts
var YEAR_MONTH_PATTERN = /^20\d{2}-(0\d|1[012])$/;
function isYearMonth(value) {
  return YEAR_MONTH_PATTERN.test(value);
}

// src/flags.ts
var flags = {
  alerts: false,
  search: false,
  live: true,
  christmas: false,
  tips: false,
  darkMode: false,
  snake: false,
  timeTrackDescription: false,
  monthlyCustomerBillings: true,
  subscriptionActivityButton: false,
  calls: false,
  insightsDailyQuarterHourlyHistogram: false,
  halloween: false,
  customerLocations: false
};
var flagKeys = Object.keys(flags);
var defaultFlags = flags;
function applyFlags(flags2) {
  return {
    ...defaultFlags,
    ...Object.fromEntries(
      Object.entries(flags2).filter(([key]) => defaultFlags.hasOwnProperty(key))
    )
  };
}

// src/preferences.ts
var preferencesDefinition = {
  workspaceLayout: {
    values: ["COMPACT", "EXPANDED"]
  },
  dashboardStatisticsGraphAdditionalInfo: {
    values: [
      "NONE",
      "REGRESSION",
      "LAST_YEAR",
      "MOVING_AVERAGE_EIGHT_WEEKS",
      "MOVING_AVERAGE_TWELVE_WEEKS"
    ]
  },
  customerOverviewAdditionalInfo: {
    values: [
      "NONE",
      "STATISTICS",
      "REQUIRED_CHECKS",
      "RECOMMENDED_CHECKS"
    ]
  },
  navigationItemWorkspaceDestination: {
    values: ["CURRENT_USER", "ALL_USERS"]
  },
  customerCategoryIndicatorNoCategoryStyle: {
    values: ["NONE", "OUTLINE"]
  }
};
var preferenceKeys = Object.keys(
  preferencesDefinition
);
var defaultPreferences = {
  workspaceLayout: "COMPACT",
  dashboardStatisticsGraphAdditionalInfo: "NONE",
  customerOverviewAdditionalInfo: "NONE",
  navigationItemWorkspaceDestination: "CURRENT_USER",
  customerCategoryIndicatorNoCategoryStyle: "NONE"
};
function coercePreference(key, value) {
  const _default = defaultPreferences[key];
  if (value === null || value === void 0) {
    return _default;
  }
  if (preferencesDefinition[key].values.includes(value)) {
    return value;
  }
  return _default;
}
function coercePreferences(values) {
  return Object.fromEntries(
    preferenceKeys.map(
      (key) => [
        key,
        coercePreference(key, values[key])
      ]
    )
  );
}
function removeDefaultPreferenceValues(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([key, value]) => defaultPreferences[key] !== value
    )
  );
}

// src/Intent.tsx
var Intent = /* @__PURE__ */ ((Intent2) => {
  Intent2["NONE"] = "none";
  Intent2["PRIMARY"] = "primary";
  Intent2["SUCCESS"] = "success";
  Intent2["WARNING"] = "warning";
  Intent2["DANGER"] = "danger";
  return Intent2;
})(Intent || {});

// src/pushCategories.ts
var pushCategories = {
  watchUpdates: {
    description: "Updates to customers and current TimeTrack for watchOS app."
  }
};

// src/customerCheckFields.ts
var customerCheckFields = {
  reference: {
    label: "Referenz"
  },
  billingAddress: {
    label: "Rechnungsaddresse"
  },
  category: {
    label: "Kategorie"
  },
  email: {
    label: "E-Mail Addresse"
  },
  workItem: {
    label: "Artikel f\xFCr Arbeitszeit"
  },
  journeyItem: {
    label: "Artikel f\xFCr Anfahrt"
  }
};

// src/notEmpty.ts
function notEmpty(value) {
  return value !== null && value !== void 0;
}

// src/formatDateRange.ts
import { format } from "date-fns";
function formatDateRange(start, end, startDate, endDate, reference) {
  console.log(start, end, startDate, endDate, reference);
  if (start.slice(0, 10) === end.slice(0, 10)) {
    if (start.slice(0, 4) === reference.slice(0, 4)) {
      return format(startDate, "d. MMMM");
    } else {
      return format(startDate, "d. MMMM yyyy");
    }
  } else if (start.slice(0, 7) === end.slice(0, 7)) {
    if (start.slice(0, 4) === reference.slice(0, 4)) {
      return format(startDate, "d.") + " - " + format(endDate, "d. MMMM");
    } else {
      return format(startDate, "d.") + " - " + format(endDate, "d. MMMM yyyy");
    }
  } else if (start.slice(0, 4) === end.slice(0, 4)) {
    if (start.slice(0, 4) === reference.slice(0, 4)) {
      return format(startDate, "d. MMMM") + " - " + format(endDate, "d. MMMM");
    } else {
      return format(startDate, "d. MMMM") + " - " + format(endDate, "d. MMMM yyyy");
    }
  } else {
    return format(startDate, "d. MMMM yyyy") + " - " + format(endDate, "d. MMMM yyyy");
  }
}
export {
  Intent,
  YEAR_MONTH_PATTERN,
  applyFlags,
  coercePreference,
  coercePreferences,
  colophonetic,
  customerCheckFields,
  defaultFlags,
  defaultPreferences,
  flagKeys,
  formatDateRange,
  isEdgeAndNodeNotNullPredicate,
  isEdgeAndNodeNotNullWithCursorPredicate,
  isNotNullPredicate,
  isYearMonth,
  normalizeSearchTerm,
  notEmpty,
  preferenceKeys,
  preferencesDefinition,
  pushCategories,
  removeDefaultPreferenceValues,
  roundEndTime,
  roundStartTime,
  workUnits,
  xray
};
//# sourceMappingURL=index.mjs.map